import React from "react";
import OhlgsAssessmentFlow from "./OhlgsAssessmentFlow";

function buildDefaultRccName(locationName) {
  if (!locationName) return "";
  return locationName.includes("RCC") ? locationName : `${locationName} RCC`;
}

export default function RegionalOhlgsReport() {
  return (
    <OhlgsAssessmentFlow
      workflowLabel="Regional RCC OHLGS"
      level="region"
      badgeLabel="Regional RCC OHLGS"
      pageTitle="OHLGS Regional Assessment"
      nameFieldLabel="Name of RCC"
      locationSummaryLabel="Selected Region"
      locationRequiredLabel="Regional context required"
      buildDefaultName={buildDefaultRccName}
      generalCommentsPlaceholder="Capture the broad observations for the RCC here..."
      recommendationsPlaceholder="Capture recommendations and required follow-up actions here..."
    />
  );
}
